export class Answer {
    sid: string;
    code: string;
    value: string;
    answer: string;
    order: string;

    constructor() {
    }
}